import { defineStore } from 'pinia'
import { localeStore } from './locale'

export interface Plans {
  id: number
  value: string
  period: string
  in_cents: number
  discount: number
  discount_value: number
  plan_name: string
  months: number
}
export const planStore = defineStore('plans', {
  state: () => ({
    plans: [] as Array<Plans>,
    languagePlans: '' as string,
    coupon: '' as string | string[],
    voucher: '' as string | string[],
    closeBannerPlanUnique: false as boolean,
    cardOnlyPromotion: false as boolean
  }),
  actions: {
    async setPlans(payload: Array<Plans>) {
      this.plans = payload
      this.setLanguagePlans()
    },
    async setLanguagePlans() {
      const store = localeStore()
      this.languagePlans = store.locale
    },
    async setCoupon(payload: string | string[]) {
      this.coupon = payload
    },
    async setVoucher(payload: string | string[]) {
      this.voucher = payload
    },
    async setCloseBanner(payload: boolean) {
      this.closeBannerPlanUnique = payload
    },
    async setCardOnlyPromotion(payload: boolean) {
      this.cardOnlyPromotion = payload
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'plans',
        storage: sessionStorage
      }
    ]
  }
})
